import request from '@/utils/request'

export function create(data) {

  return request({
    url: '/baseDataZXXSGFYDJ/create',
    method: 'POST',
    data})
}

   

export function createBatch(data) {

  return request({
    url: '/baseDataZXXSGFYDJ/create/batch',
    method: 'POST',
    data})
}

   

export function deleteById(data) {

  return request({
    url: '/baseDataZXXSGFYDJ/deleteById',
    method: 'POST',
    data})
}

   

export function deleteByIds(data) {

  return request({
    url: '/baseDataZXXSGFYDJ/deleteByIds',
    method: 'POST',
    data})
}

   

export function getById(params) {

  return request({
    url: '/baseDataZXXSGFYDJ/getById',
    method: 'GET',
    params})
}

   

export function getByIds(params) {

  return request({
    url: '/baseDataZXXSGFYDJ/getByIds',
    method: 'GET',
    params})
}

   

export function list(params) {

  return request({
    url: '/baseDataZXXSGFYDJ/list',
    method: 'GET',
    params})
}

   

export function update(data) {

  return request({
    url: '/baseDataZXXSGFYDJ/update',
    method: 'POST',
    data})
}

   

export function updateBatch(data) {

  return request({
    url: '/baseDataZXXSGFYDJ/update/batch',
    method: 'POST',
    data})
}

   